
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.312 15c.624 0 1.12-.393 1.567-.942.913-1.125-.586-2.024-1.158-2.464a3.623 3.623 0 00-1.888-.76M15 9.166A2.083 2.083 0 0015 5M2.689 15c-.624 0-1.121-.393-1.567-.942-.913-1.125.586-2.024 1.158-2.464a3.624 3.624 0 011.887-.76m.417-1.667a2.083 2.083 0 010-4.167","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M6.737 12.593c-.851.526-3.084 1.601-1.724 2.947.664.657 1.404 1.127 2.334 1.127h5.307c.93 0 1.67-.47 2.334-1.128 1.36-1.345-.872-2.42-1.724-2.946a6.214 6.214 0 00-6.527 0z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.917 6.25a2.917 2.917 0 11-5.833 0 2.917 2.917 0 015.833 0z","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    